import React, { useState } from "react";
import { Settings, Info } from "lucide-react";
import NodeInfoPanel from "./NodeInfoPanel";

/**
 * Configure | Info tabs for flow node expanded editors.
 * Wrap the existing form as children (Configure tab).
 */
const NodeEditorTabs = ({ nodeType, children, defaultTab = "configure" }) => {
  const [tab, setTab] = useState(defaultTab);

  const tabBtn = (id, label, Icon) => (
    <button
      type="button"
      onClick={() => setTab(id)}
      className={`flex-1 flex items-center justify-center gap-1.5 py-2 text-[11px] font-bold rounded-lg transition-colors ${
        tab === id
          ? "bg-white text-indigo-800 shadow-sm border border-indigo-100"
          : "text-gray-600 hover:text-gray-900 hover:bg-white/60"
      }`}
    >
      <Icon size={13} />
      {label}
    </button>
  );

  return (
    <div className="mb-0">
      <div className="flex gap-1.5 p-1 bg-gray-100/90 rounded-lg mb-3">
        {tabBtn("configure", "Configure", Settings)}
        {tabBtn("info", "Info", Info)}
      </div>

      {tab === "configure" ? (
        <div className="min-h-0">{children}</div>
      ) : (
        <NodeInfoPanel nodeType={nodeType} />
      )}
    </div>
  );
};

export default NodeEditorTabs;
